import { CircularProgress, Grid, Typography } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const AmountRow = ({
  visibility = false,
  label = "",
  amount = "",
  isDiscount = false,
  isHighlightedText = false,
}) => {
  const { t } = useTranslation();
  const { loadingInvoiceData } = useSelector((state) => state.payForAd);

  return visibility ? (
    <Grid container direction="row" justifyContent="space-between">
      <Typography
        variant={isHighlightedText ? "body1" : "body2"}
        style={{ fontWeight: isHighlightedText ? 600 : 400 }}
      >
        {label}
      </Typography>
      {loadingInvoiceData ? (
        <CircularProgress size={15} className="primary-circular-progress" />
      ) : (
        <Typography
          variant={isHighlightedText ? "body1" : "body2"}
          style={{ fontWeight: isHighlightedText ? 600 : 400 }}
        >
          {isDiscount ? `- ${amount}` : amount}
        </Typography>
      )}
    </Grid>
  ) : null;
};

export default AmountRow;
